import { CATEGORIES } from "../data/questions";
import { getMaturityLevel } from "./scoreCalculator";

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

function listSection(title, items) {
  const entries = items?.length ? items : ["None identified"];
  return `
    <section>
      <h2>${escapeHtml(title)}</h2>
      <ul>${entries.map((item) => `<li>${escapeHtml(item)}</li>`).join("")}</ul>
    </section>`;
}

export function downloadAssessmentReport({ overallScore, categoryScores, insights }) {
  const maturity = getMaturityLevel(overallScore);
  const generatedAt = new Intl.DateTimeFormat("en", {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(new Date());

  const categoryBreakdown = CATEGORIES.map(
    (category) => `<tr><td>${escapeHtml(category.label)}</td><td>${Math.round(categoryScores[category.key] || 0)}/100</td></tr>`,
  ).join("");

  const report = `<!DOCTYPE html>
<html><head><meta charset="utf-8"><title>ONYXX AI Readiness Assessment</title>
<style>
  body { font-family: Arial, sans-serif; color: #17203b; margin: 42px; line-height: 1.55; }
  h1 { color: #2d2560; font-size: 25pt; margin: 0; } h2 { color: #0d7f96; font-size: 14pt; margin: 26px 0 8px; }
  .eyebrow { color: #0d9bb5; font-size: 9pt; font-weight: bold; letter-spacing: 1px; }
  .meta { color: #5d6879; margin: 8px 0 25px; } .score { background: #f1f9fb; border-left: 5px solid #0d9bb5; padding: 16px; }
  .score strong { font-size: 18pt; color: #2d2560; } table { border-collapse: collapse; width: 100%; } td { border-bottom: 1px solid #dce3eb; padding: 9px; } td:last-child { text-align: right; font-weight: bold; }
  li { margin: 6px 0; } .footer { margin-top: 30px; color: #5d6879; font-size: 9pt; }
</style></head><body>
  <p class="eyebrow">CLOUDISIAN | CONFIDENTIAL ASSESSMENT RESULT</p>
  <h1>ONYXX AI Readiness Assessment</h1>
  <p class="meta">Generated ${generatedAt}</p>
  <div class="score"><strong>${overallScore}/100</strong><br>Maturity level: <b>${escapeHtml(maturity.label)}</b></div>
  <section><h2>Executive Summary</h2><p>${escapeHtml(insights.summary)}</p></section>
  <section><h2>Category Breakdown</h2><table>${categoryBreakdown}</table></section>
  ${listSection("Key Strengths", insights.strengths)}
  ${listSection("Priority Risks", insights.risks)}
  ${listSection("Recommended Next Steps", insights.recommendations)}
  <p class="footer">For a tailored action plan, contact Cloudisian.</p>
</body></html>`;

  const blob = new Blob([report], { type: "application/msword;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = "onyxx-ai-readiness-assessment.doc";
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
